import { Injectable, Inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import Swal from 'sweetalert2';
import { MODALES } from '../Utils/global';
import { PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class HelperService {
  private modalSelected = new BehaviorSubject<MODALES>(null);

  public $abrirModal = this.modalSelected.asObservable();
  isBrowser: boolean;

  constructor(@Inject(PLATFORM_ID) platformId) {
    this.isBrowser = isPlatformBrowser(platformId);

  }

  errorInesperado() {
    Swal.fire('UPS!', 'Ha ocurrido un error interno. <br>Intente nuevamente en un momento.', 'error');
  }

  abrirModal(modal: MODALES) {
    this.modalSelected.next(modal);

    setTimeout(() => {
      this.modalSelected.next(null);
    }, 500);
  }

  toCamelCase(str) {
    // console.log("STR", str)
    return str.split(' ').map(function (word, index) {
      // If it is the first word make sure to lowercase all the chars.
      if (index == 0) {
        return word.toLowerCase();
      }
      // If it is not the first word only upper case the first char and lowercase the rest.
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    }).join('');
  }

  async getBase64ImageFromUrl(imageUrl) { //Obtener un Base64 del URL de las imagenes.
    if (this.isBrowser) {
      var res = await fetch(imageUrl);
      var blob = await res.blob();

      return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.addEventListener("load", function () {
          resolve(reader.result);
        }, false);

        reader.onerror = () => {
          return reject(this);
        };
        reader.readAsDataURL(blob);
      })
    }
  }

}
